export interface PendingUser {
  id: string;
  firstName: string;
  lastName: string;
  createdAt: string;
}

export enum UserStatus {
  Inactive = 'inactive',
  Active = 'active',
  PendingRequest = 'pending-request',
  Declined = 'declined',
}

